<template>
  <div id="app">
    <transition>
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  data(){
    return {}
  },
  methods: {
    handleWindowResize() {
      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
  },
  mounted() {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    if(/iP(hone|ad)/.test(window.navigator.userAgent)) {
      document.body.addEventListener('touchstart', function() {}, false);
    }
  },
  async created() {
    document.documentElement.setAttribute('dir', 'ltr')
    window.addEventListener('resize', this.handleWindowResize)

  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>

<style lang="scss">
#app {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// Badge reCAPTCHA v3 nascosto: si usa visibility e non display:none
// per non compromettere il funzionamento del widget invisibile.
// L'informativa Google richiesta dai termini di servizio e' esposta nei form.
.grecaptcha-badge {
  visibility: hidden;
}

.recaptcha-disclaimer {
  font-size: 11px;
  line-height: 1.4;
}
</style>